<ng-template #railairtemp let-r="result" let-t="term">
  <div class="light-flex">
    @if (!r.group) {
      <i class="custom_icon-eurostar item-icon"></i>
    }
    @if (r.group) {
      <span class="multiairportgrouping">
        <i class="custom_icon-eurostar"></i>
      </span>
    }
    <span class="item-code">{{ r.code }}</span>
    <span class="item-dest">{{ r.destination | flightFormat }} ({{ r.gateway }})</span>
  </div>
</ng-template>

<div class="eurostar-search-container">
  <div>
    <app-light-toggle-group tabindex="-1">
      <app-light-toggle-btn
        [selected]="searchParams.chosenSearchType === EurostarSearchType.oneWay"
        (click)="
          searchParams.chosenSearchType = EurostarSearchType.oneWay;
          searchService.isFavoritesSelected = false
        "
        iconClass="ico-oneway"
        tabindex="-1"
        id="eurostar-toggle-one-way"
        i18n="@@eurostarSearchOneWayOnly"
        >One way</app-light-toggle-btn
      >
      <app-light-toggle-btn
        [selected]="searchParams.chosenSearchType === EurostarSearchType.return"
        (click)="
          searchParams.chosenSearchType = EurostarSearchType.return;
          searchService.isFavoritesSelected = false
        "
        iconClass="ico-return"
        tabindex="-1"
        id="eurostar-toggle-return"
        i18n="@@eurostarSearchReturnTrip"
        >Return
      </app-light-toggle-btn>
    </app-light-toggle-group>
  </div>
  @if (!searchService.isFavoritesSelected) {
    <div class="half-container flex-row-container locations-wrapper">
      <div class="half-block">
        <label
          id="outboundJourney"
          class="header-label"
          for="euro-outbound-journey"
          i18n="@@eurostarSearchOutboundJourney"
          >From
        </label>
        <i class="custom_icon-eurostar combo-box-icon"></i>
        <input
          #ofd
          id="euro-outbound-journey"
          autocomplete="off"
          name="outboundJourney"
          placeholder="Enter a station"
          i18n-placeholder
          type="text"
          class="combo-box"
          [(ngModel)]="searchParams.departLocation"
          (selectItem)="checkHotelCheckbox()"
          [ngbTypeahead]="getOutStations"
          (click)="outboundClick$.next($event.target.value)"
          [resultTemplate]="railairtemp"
          [inputFormatter]="formatter_rail_air"
          aria-labelledby="outboundJourney"
          (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
          (keyup.arrowup)="ensureElementIsScrolledTo($event)"
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Please add in a departure location'
            )
          }"
        />
        @if (loadingOutbound) {
          <i class="button_spinner input-loading-spinner-left"></i>
        }
      </div>
      <app-swap-button
        class="eurostar"
        [departLocation]="searchParams.departLocation"
        [arriveLocation]="searchParams.arriveLocation"
        (locationsSwapped)="handleLocationsSwapped($event)"
      >
      </app-swap-button>
      <div class="half-block">
        <label
          id="inboundJourney"
          class="header-label"
          for="eurostar-inbound-journey"
          i18n="@@eurostarSearchInboundJourney"
          >To
        </label>
        <i class="custom_icon-eurostar combo-box-icon"></i>
        <input
          #ofa
          id="eurostar-inbound-journey"
          autocomplete="off"
          name="inboundJourney"
          placeholder="Enter a station"
          i18n-placeholder
          type="text"
          class="combo-box"
          [(ngModel)]="searchParams.arriveLocation"
          (selectItem)="checkHotelCheckbox()"
          [ngbTypeahead]="getInStations"
          (click)="inboundClick$.next($event.target.value)"
          [resultTemplate]="railairtemp"
          [inputFormatter]="formatter_rail_air"
          aria-labelledby="inboundJourney"
          (keyup.arrowdown)="ensureElementIsScrolledTo($event)"
          (keyup.arrowup)="ensureElementIsScrolledTo($event)"
          [ngClass]="{
            'error-box': searchParams.validationMessages?.includes(
              'Please add in a arrival destination'
            )
          }"
        />
        @if (loadingInbound) {
          <i class="button_spinner input-loading-spinner-left"></i>
        }
      </div>
    </div>
    @if (
      {
        criteria: (searchParams.timeCriteriaOptions | async) || []
      };
      as data
    ) {
      <div class="half-container flex-row-container">
        <div class="half-block">
          <div class="flex-row-container">
            <ngbd-datepicker-i18n>
              <div class="flex-column-container combo-box-left">
                <label
                  class="header-label date-label"
                  i18n="@@ferrySearchOutboundDate"
                  for="euro-outbound-date"
                  >Outbound date (DD/MM/YYYY)</label
                >
                <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                <app-datepicker
                  [minDate]="searchParams.minimumOutBoundDate"
                  [startDate]="searchParams.departDate"
                  [model]="searchParams.departDate"
                  [from]="
                    searchParams.chosenSearchType === EurostarSearchType.return
                      ? searchParams.departDate
                      : null
                  "
                  [to]="
                    searchParams.chosenSearchType === EurostarSearchType.return
                      ? searchParams.returnDate
                      : null
                  "
                  (newFrom)="searchParams.departDate = $event; checkHotelCheckbox()"
                  (newTo)="searchParams.returnDate = $event; checkHotelCheckbox()"
                  [class]="'combo-box'"
                  [componentId]="'euro-outbound-date'"
                  (newDate)="searchParams.departDate = $event; checkHotelCheckbox()"
                >
                </app-datepicker>
              </div>
              <div class="flex-column-container select-box-right">
                <div
                  class="flex-row-container flex-row-container--between flex-row-container--v-center"
                >
                  <label
                    class="header-label"
                    i18n="@@AriaRailOutboundTime"
                    for="eurostar-outbound-time"
                    >Outbound time</label
                  >
                  @if (searchParams.outTimeCriteria === TimeWindow.Arrive) {
                    <span class="time-criteria" i18n="@@EurostarPlusMinus2Hours">± 2hrs</span>
                  }
                </div>
                <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                <select
                  appSelect
                  #oft
                  id="eurostar-outbound-time"
                  [ngClass]="{
                    time_disabled: searchParams.outTimeCriteria === TimeWindow.Anytime
                  }"
                  [(ngModel)]="searchParams.departTime"
                  [disabled]="searchParams.outTimeCriteria === TimeWindow.Anytime"
                  tabindex="0"
                >
                  @for (time of searchParams.timeArray; track time) {
                    <option [ngValue]="time.value">
                      {{ time.display }}
                    </option>
                  }
                </select>
              </div>
            </ngbd-datepicker-i18n>
          </div>
          <div
            class="flex-row-container flex-row-container--right flex-row-container--tb-margin flex-row-container--reset"
          >
            <span id="search-eurostar-time-preferences" hidden i18n="@@AriaEurostarTimePreferences"
              >Time preferences</span
            >
            <mat-radio-group
              [(ngModel)]="searchParams.outTimeCriteria"
              labelPosition="after"
              aria-label="outbound journey time preferences"
              class="triple-radio-buttons"
            >
              @for (crit of data.criteria; track crit) {
                <mat-radio-button
                  class="light-primary"
                  color="primary"
                  [value]="crit"
                  id="euro-outbound-timepref-{{ crit }}"
                >
                  {{ crit | translate }}
                </mat-radio-button>
              }
            </mat-radio-group>
          </div>
        </div>
        @if (searchParams.isReturn) {
          <div class="half-block">
            <div class="flex-row-container">
              <ngbd-datepicker-i18n>
                <div class="flex-column-container combo-box-left">
                  <label
                    class="header-label date-label"
                    i18n="@@ferrySearchReturnDate"
                    for="euro-return-date"
                    >Return date (DD/MM/YYYY)</label
                  >
                  <i class="ico-calendar combo-box-icon cursor_pointer" aria-hidden="true"></i>
                  <app-datepicker
                    [minDate]="searchParams.minimumOutBoundDate"
                    [startDate]="searchParams.returnDate || searchParams.departDate"
                    [model]="searchParams.returnDate"
                    [from]="
                      searchParams.chosenSearchType === EurostarSearchType.return
                        ? searchParams.departDate
                        : null
                    "
                    [to]="
                      searchParams.chosenSearchType === EurostarSearchType.return
                        ? searchParams.returnDate
                        : null
                    "
                    (newFrom)="searchParams.departDate = $event; checkHotelCheckbox()"
                    (newTo)="searchParams.returnDate = $event; checkHotelCheckbox()"
                    [class]="'combo-box'"
                    [componentId]="'euro-return-date'"
                    (newDate)="searchParams.returnDate = $event; checkHotelCheckbox()"
                  >
                  </app-datepicker>
                </div>
                <div class="flex-column-container select-box-right">
                  <div
                    class="flex-row-container flex-row-container--between flex-row-container--v-center"
                  >
                    <label
                      class="header-label"
                      i18n="@@AriaFerryReturnDate"
                      for="eurostar-return-time"
                      >Return time</label
                    >
                    @if (searchParams.inTimeCriteria === TimeWindow.Arrive) {
                      <span class="time-criteria" i18n="@@EurostarPlusMinus2Hours">± 2hrs</span>
                    }
                  </div>
                  <i class="ico-clock select-box-icon" aria-hidden="true"></i>
                  <select
                    appSelect
                    id="eurostar-return-time"
                    [ngClass]="{
                      time_disabled: searchParams.inTimeCriteria === TimeWindow.Anytime
                    }"
                    [(ngModel)]="searchParams.arriveTime"
                    [disabled]="searchParams.inTimeCriteria === TimeWindow.Anytime"
                    tabindex="0"
                  >
                    @for (time of searchParams.timeArray; track time) {
                      <option [ngValue]="time.value">
                        {{ time.display }}
                      </option>
                    }
                  </select>
                </div>
              </ngbd-datepicker-i18n>
            </div>
            @if (searchParams.chosenSearchType === EurostarSearchType.return) {
              <div
                class="flex-row-container flex-row-container--between flex-row-container--tb-margin flex-row-container--reset"
              >
                <span id="search-eurostar-return-prefs" hidden i18n="@@SearchEurostarReturnPrefs"
                  >Return preferences</span
                >
                <mat-radio-group
                  [(ngModel)]="searchParams.inTimeCriteria"
                  labelPosition="after"
                  aria-labelledby="search-eurostar-return-prefs"
                  class="triple-radio-buttons timecrit-buttons"
                >
                  @for (crit of data.criteria; track crit) {
                    <mat-radio-button
                      class="light-primary"
                      color="primary"
                      [value]="crit"
                      id="euro-return-timepref-{{ crit }}"
                    >
                      {{ crit | translate }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (
      {
        avaliableClasses: (searchParams.avaliableClasses | async) || []
      };
      as data
    ) {
      <div class="flex-row-container flex-row-container--right">
        @if (resultsMode) {
          <button appButton="large-search" (click)="search()" i18n="@@eurostarSearchButton">
            Search
          </button>
        }
      </div>
      <div class="flex-row-container">
        <h2 i18n="@@eurostarSearchOptions" class="rem-1-5">Options</h2>
      </div>
      <div class="half-container">
        <div class="half-block">
          <label
            class="header-label"
            id="PreferredClassO"
            i18n="@@eurostarSearchChooseClassOut"
            for="eurostar-class-outbound"
            >Outbound class</label
          >
          <section (mouseleave)="tt.close()" class="container">
            <i
              class="ico-info fare-rules-ico"
              (click)="openFareRulesAndFocus()"
              (keydown.enter)="openFareRulesAndFocus()"
              (keydown)="openFareRulesWithSpace($event)"
              ngbTooltip="For more information regarding the fare conditions select here"
              placement="top"
              aria-label="For more information regarding the fare conditions select here"
              alt="For more information regarding the fare conditions select here"
              i18n-ngbTooltip
              i18n-aria-label
              tabindex="0"
              role="button"
              triggers="manual"
              #tt="ngbTooltip"
              (mouseenter)="tt.open()"
              (focus)="tt.open()"
              (blur)="tt.close()"
              tabindex="0"
              id="fare-rules-icon"
              ><span class="visuallyhidden"
                >For more information regarding the fare conditions select here</span
              ></i
            >
          </section>
          <select
            appSelect
            [noIcon]="true"
            [(ngModel)]="searchParams.cabinClass"
            aria-labelledby="PreferredClassO"
            id="eurostar-class-outbound"
          >
            @for (class of data.avaliableClasses; track class) {
              <option [value]="class.type">
                {{ class.name | translate }}
              </option>
            }
          </select>
        </div>
        <div class="half-block">
          @if (searchParams.chosenSearchType === EurostarSearchType.return) {
            <label
              class="header-label"
              id="PreferredClassI"
              i18n="@@eurostarSearchChooseClassIn"
              for="eurostar-class-inbound"
              >Return class</label
            >
            <select
              appSelect
              [noIcon]="true"
              [(ngModel)]="searchParams.returnCabinClass"
              aria-labelledby="PreferredClassI"
              id="eurostar-class-inbound"
            >
              @for (class of data.avaliableClasses; track class) {
                <option [value]="class.type">
                  {{ class.name | translate }}
                </option>
              }
            </select>
          }
        </div>
      </div>
    }
    <div class="flex-column-container flex-column-container--tb-margin">
      <mat-checkbox
        class="light-primary"
        color="primary"
        [checked]="searchParams.maxConnections === 0"
        #checked
        id="euro-direct-only"
        (change)="direct(checked.checked)"
        (keydown.enter)="direct(checked)"
        i18n="@@eurostarSearchDirectOnly"
      >
        Direct only
      </mat-checkbox>
    </div>
    @if (
      searchParams.chosenSearchType === EurostarSearchType.return &&
      displayHotelCheck &&
      toggleHotelSearchRequested.observed &&
      services[ServiceType.Hotel]
    ) {
      <div class="flex-row-container hotel-check">
        <button
          appButton="large"
          color="primary"
          [attr.aria-pressed]="hotelsearchRequested"
          id="eurostar-checkbox-hotel-{{ hotelsearchRequested ? 'remove' : 'add' }}"
          (click)="toggleHotelCheckbox()"
        >
          @if (!hotelsearchRequested) {
            <span i18n="@@eurostarAddHotelcheck"> Add Hotel </span>
          }
          @if (hotelsearchRequested) {
            <span i18n="@@eurostarRemoveHotelcheck"> Remove Hotel </span>
          }
        </button>
      </div>
    }
  } @else {
    <app-favorite-items [serviceType]="ServiceType.Eurostar"> </app-favorite-items>
  }

  @if (
    hotelsearchRequested &&
    toggleHotelSearchRequested.observed &&
    searchParams.chosenSearchType === EurostarSearchType.return
  ) {
    <h2 class="hotel-header">Hotel</h2>
    <app-hotel-search></app-hotel-search>
  }
  <app-eurostar-loading-screen></app-eurostar-loading-screen>
</div>
